export default __webpack_public_path__ + "static/media/order-list-blue.d7f0c830.svg";